import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const PersonalAssessmentList = ({ items, onView }) => {
    const tHeads = [
        { title: "SN", width: "5%", className: "text-center" },
        { title: "Health State", width: "15%", className: "text-center" },
        { title: "Staff", width: "20%", className: "text-left" },
        {
            title: "Date & Time",
            width: "15%",
            className: "text-left",
        },
        {
            title: "View",
            width: "10%",
            className: "text-center",
        },
    ];
    if (items.length)
        return (
            <>
                <table className="table table-bordered">
                    <thead>
                        {tHeads.map((item) => (
                            <th style={{ width: item.width }} key={item.title} className={item.className}>
                                {item.title}
                            </th>
                        ))}
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <strong>{idx + 1}</strong>
                                </td>
                                <td className="text-center">
                                    <h5>{item.health_state}</h5>
                                </td>
                                <td>
                                    <StaffProfileCard item={item.author} />
                                </td>
                                <td>{cleanDate(item.created_at)}</td>
                                <td className="text-center">
                                    <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    return (
        <div className="text-center mt-5">
            <h4 className="text-pink">No Record Found!</h4>
            <p>No Personal Assessment has been created for this patient.</p>
        </div>
    );
};

export default PersonalAssessmentList;
